import React from 'react';

/**
 * Inline JbnWorks bulb-and-circuit mark. Rendered inline (no external file) so it
 * is always visible regardless of asset paths or build base URL.
 */
const BrandMark = ({ className = 'brand-mark', color = '#E4C77E' }) => (
  <svg
    className={className}
    viewBox="0 0 120 120"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="JbnWorks"
  >
    <g fill="none" stroke={color} strokeWidth="7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M38 52 C38 26, 56 10, 74 10 C92 10, 100 26, 100 46 C100 62, 92 70, 88 80 L50 80 C46 70, 38 66, 38 52 Z" />
      <path d="M52 92 L86 92" />
      <path d="M56 104 L82 104" />
    </g>
    <g fill={color}>
      <circle cx="66" cy="30" r="5" />
      <circle cx="86" cy="44" r="5" />
      <circle cx="64" cy="58" r="5" />
    </g>
    <g fill="none" stroke={color} strokeWidth="3">
      <path d="M66 35 Q76 40, 84 44" />
      <path d="M84 49 Q74 54, 66 57" />
      <path d="M60 57 Q50 50, 46 42" />
    </g>
  </svg>
);

export default BrandMark;
